import { useState, useCallback, useEffect } from 'react';
import apiService from '../services/api-mini';

export const useConti = () => {
  const [conti, setConti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);

  // Carica i conti dal database
  const fetchConti = useCallback(async () => {

    debugger;

    try {
      setLoading(true);
      setError(null);
      const data = await apiService.getConti();
      setConti(data);
    } catch (err) {
      setError(err.message);
      console.error('Errore nel caricamento conti:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  // Login
  const login = useCallback(async (username, password) => {
    try {
      const response = await apiService.login(username, password);
      setUser(response.user);
      return response;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  }, []);

  // Logout
  const logout = useCallback(async () => {
    try {
      await apiService.logout();
      setUser(null);
      setConti([]);
    } catch (err) {
      console.error('Logout error:', err);
    }
  }, []);

  // Inizializza utente da localStorage
  useEffect(() => {
    const savedUser = localStorage.getItem('gledger_user');
    if (savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (err) {
        console.error('Error parsing saved user:', err);
        localStorage.removeItem('gledger_user');
      }
    }
  }, []);

  // Carica conti quando l'utente è disponibile
  useEffect(() => {
    if (user) {
      fetchConti();
    } else {
      // Se non c'è utente, imposta loading a false per mostrare il login
      setLoading(false);
    }
  }, [user, fetchConti]);

  // Create conto
  const createConto = useCallback(async (contoData) => {
    try {
      const newConto = await apiService.createConto(contoData);
      setConti(prev => [...prev, newConto]);
      return newConto;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  }, []);

  // Update conto
  const updateConto = useCallback(async (id, contoData) => {
    try {
      const updatedConto = await apiService.updateConto(id, contoData);
      setConti(prev => prev.map(conto => 
        conto.id === id ? updatedConto : conto
      ));
      return updatedConto;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  }, []);

  // Delete conto
  const deleteConto = useCallback(async (id) => {
    try {
      await apiService.deleteConti(id);
      setConti(prev => prev.filter(conto => conto.id !== id));
    } catch (err) {
      setError(err.message);
      throw err;
    }
  }, []);

  // Move conto
  const moveConto = useCallback(async (contoId, newParentId) => {
    try {
      const updatedConto = await apiService.moveConto(contoId, newParentId);
      setConti(prev => prev.map(conto => 
        conto.id === contoId ? updatedConto : conto
      ));
      return updatedConto;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  }, []);

  // Duplicate conto
  const duplicateConto = useCallback(async (id, newName) => {
    try {
      const newConto = await apiService.duplicateConto(id, newName);
      setConti(prev => [...prev, newConto]);
      return newConto;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  }, []);

  return {
    conti,
    loading,
    error,
    user,
    login,
    logout,
    refetch: fetchConti,
    createConto,
    updateConto,
    deleteConto,
    moveConto,
    duplicateConto
  };
};
